module.exports = __webpack_public_path__ + "static/homepage-2fd897449707e0d76f5e8ae6c50bd2ab.jpg";